/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import type { FunctionComponent, JSX } from "react";

import type { AlertOverlayProps } from "./AlertOverlayProps";

import "./AlertOverlay.scss";

const AlertOverlay: FunctionComponent<AlertOverlayProps> = (
  props: AlertOverlayProps
): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, sonarjs/no-unused-vars, sonarjs/no-dead-store -- Required by CodingGuidelines §7 (D-09)
  const TAG: string = "AlertOverlay";
  const {
    title,
    message,
    actions,
    focusedActionIndex,
    retryPending,
    onAction,
    variant
  } = props;

  const dialogClassName: string =
    "alert-overlay__dialog" +
    (variant === "info" ? " alert-overlay__dialog--info" : "");

  return (
    <div className="alert-overlay">
      <div className="alert-overlay__backdrop" />
      <div className={dialogClassName}>
        <h2 className="alert-overlay__title">{title}</h2>
        <p className="alert-overlay__message">{message}</p>
        {actions.length > 0 && (
          <div className="alert-overlay__actions">
            {actions.map(
              (
                action: {
                  id: string;
                  label: string;
                  keepsOverlayOpen?: boolean;
                },
                index: number
              ): JSX.Element => {
                const isDisabled: boolean =
                  retryPending && action.keepsOverlayOpen === true;
                const buttonClassName: string =
                  "alert-overlay__action-button" +
                  (index === focusedActionIndex
                    ? " alert-overlay__action-button--focused"
                    : "") +
                  (isDisabled ? " alert-overlay__action-button--loading" : "");
                return (
                  <button
                    key={action.id}
                    className={buttonClassName}
                    type="button"
                    tabIndex={0}
                    disabled={isDisabled}
                    onClick={(): void => onAction(action.id)}
                  >
                    {action.label}
                  </button>
                );
              }
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AlertOverlay;
